import ApiService from "@/core/services/api.service";
import i18n from "@/core/plugins/vue-i18n";
import CoreSettingsJs from "@shared/src/core/services/settings.js";
import i18nService from "@/core/services/i18n.service.js";

const warehouseSelection = async function (post_data = {}) {
	let response = await ApiService.post("warehouse/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const warehouseCountrySelection = async function (marking_id = null) {
	let response = await ApiService.post("warehouse/country-selection", {
		locale: i18n.locale,
		marking_id: marking_id,
		country_id: null,
		admin_portal: 1
	});

	return response.data.code == "200" ? response.data.result : [];
};

const warehouseSettingsSelection = async function (post_data = {}) {
	let response = await ApiService.post("warehouse-settings/search", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const customerSelection = async function (post_data = {}) {
	let response = await ApiService.post(`customer/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const mainSalesmanSelection = async function (post_data = {}) {
	let response = await ApiService.post(`main-salesman/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const salesmanSelection = async function (post_data = {}) {
	let response = await ApiService.post(`salesman/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const deliveryZoneSelection = async function () {
	let response = await ApiService.get(`delivery-zone/selection`);
	return response.data.code == "200" ? response.data.result : [];
};

const deliveryAddressSelection = async function (post_data = {}) {
	let response = await ApiService.post(`delivery-address/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const companyGroupSelection = async function (post_data = {}) {
	let response = await ApiService.post(`company/group-selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const getCourierCompanySelection = async function (post_data = {}) {
	let response = await ApiService.post(`courier-company/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const getMaintainAgentSelection = async function () {
	let response = await ApiService.post(`maintain-agent/selection`);
	return response.data.code == "200" ? response.data.result : [];
};

const getAgentCourierSelection = async function (post_data = {}) {
	let response = await ApiService.post(`maintain-agent/agent_courier/selection`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const categoryLvl2Selection = async function (post_data = {}) {
	let response = await ApiService.post(`category/second-level-all`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const taxSelection = async function () {
	let response = await ApiService.get(`tax/selection-all`);
	return response.data.code == "200" ? response.data.result : [];
};

const supplierSelection = async function (post_data = {}) {
	let response = await ApiService.post(`supplier/list`, post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const markingSelection = async function (post_data = {}) {
	let response = await ApiService.post("customer-marking/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const statusSelection = [
	{
		item: null,
		name: i18n.t("COMMON.TXT_ALL")
	},
	{
		item: 1,
		name: i18n.t("COMMON.STATUS.ACTIVE")
	},
	{
		item: 0,
		name: i18n.t("COMMON.STATUS.INACTIVE")
	}
];

const yesNoSelection = function (include_all = 0) {
	let selection = [];
	if (include_all == 1) {
		selection.push({
			id: null,
			name: i18n.t("COMMON.TXT_ALL")
		});
	}
	return selection.concat([
		{
			id: 1,
			name: i18n.t("COMMON.STATUS.YES")
		},
		{
			id: 0,
			name: i18n.t("COMMON.STATUS.NO")
		}
	]);
};

const uploadFile = async function (data) {
	let response = await ApiService.uploadfile("upload/image", data, {
		headers: {
			"Content-Type": "multipart/form-data"
		}
	});

	if (response.status == "200" && response.data.code == "200") {
		if (response.data.result.fileDownloadUri != null || response.data.result.fileDownloadUri != undefined) {
			return response.data.result.fileDownloadUri;
		} else {
			return null;
		}
	} else {
		return null;
	}
};
const shipmentTypeSelection = async function (post_data = {}) {
	post_data = {
		locale: i18nService.getActiveLanguage(),
		...post_data
	};
	var response = await ApiService.post("shipment-type/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const shipmentModeSelection = async function (post_data = {}) {
	post_data = {
		locale: i18nService.getActiveLanguage(),
		...post_data
	};
	let response = await ApiService.post("shipment-mode/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const countrySelection = async function () {
	let response = await ApiService.get("countries/active");
	return response.data.code == "200" ? response.data.result : [];
};

const refIdSelection = async function (post_data = {}) {
	let response = await ApiService.post("container-loading/ref-ids", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const noticeTypeSelection = async function (post_data = {}) {
	let response = await ApiService.post("notice-type/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const currencySelection = async function (post_data = {}) {
	let response = await ApiService.post("currency/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const packingTypeSelection = async function (post_data = {}) {
	let response = await ApiService.post("packing-type/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const userTypeSelection = [
	{
		id: 1,
		name: i18n.t("COMMON.USER_TYPE.WAREHOUSE_STAFF")
	},
	{
		id: 2,
		name: i18n.t("COMMON.USER_TYPE.AGENT_STAFF")
	}
];

const userSelection = async function (post_data = {}) {
	//userSelection
	let response = await ApiService.post("user/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const agentSelection = async function (post_data = {}) {
	let response = await ApiService.post("agent/selection", post_data);
	return response.data.code == 200 ? response.data.result : [];
};

const markingStatusSelection = [
	{
		id: 0,
		name: i18n.t("COMMON.STATUS.INACTIVE"),
		color: "dange"
	},
	{
		id: 1,
		name: i18n.t("COMMON.STATUS.ACTIVE"),
		color: "success"
	},
	{
		id: 3,
		name: i18n.t("COMMON.STATUS.SUSPEND"),
		color: "warning"
	}
];

const callingCodeSelection = async function () {
	let response = await ApiService.get("countries/phone-code");
	return response.data.code == "200" ? response.data.result : [];
};

const deliveryAgentSelection = async function (post_data = {}) {
	let response = await ApiService.post("delivery-agent/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const epoStatusSelection = async function (ignore_draf = false) {
	let response = await ApiService.post("epo-status/selection", { locale: i18n.locale });
	const draftOption = ignore_draf ? [] : [{ id: 0, name: i18n.t("COMMON.STATUS.DRAFT"), status: 1 }];
	return response.data.code == "200" ? [...draftOption, ...response.data.result] : draftOption;
};

const portSelection = async function (post_data = {}) {
	let response = await ApiService.post("port/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const refTypeSelection = async function (post_data = {}) {
	let response = await ApiService.post("ref-type/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const numResetSelection = [
	{
		id: 0,
		name: i18n.t("MASTER_DATA.DOC_NUM.SELECTION.NO_RESET")
	},
	{
		id: 1,
		name: i18n.t("MASTER_DATA.DOC_NUM.SELECTION.BY_MONTH")
	},
	{
		id: 2,
		name: i18n.t("MASTER_DATA.DOC_NUM.SELECTION.BY_YEAR")
	}
];

const responseValidation = function (response) {
	return response.data.code == "200" && !CoreSettingsJs.emptyObjectValidation(response.data.result) ? true : false;
};

const docTypeSelection = async function () {
	let response = await ApiService.get("doc-type/selection");
	return response.data.code == "200" ? response.data.result : [];
};

const uomSelection = async function (post_data = { use_epo_inv_receive: 1 }) {
	let response = await ApiService.post("uom/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const warehouseLocationSelection = async function (post_data = {}) {
	let response = await ApiService.post("warehouse-location/selection", post_data);
	return response.data.code == "200" ? response.data.result : [];
};

const postingSideSelection = [
	{
		id: 0,
		name: i18n.t("MASTER_DATA.DOC_TYPE.SELECTION.NO_POSTING")
	},
	{
		id: 1,
		name: i18n.t("MASTER_DATA.DOC_TYPE.SELECTION.CREDIT")
	},
	{
		id: 2,
		name: i18n.t("MASTER_DATA.DOC_TYPE.SELECTION.DEBIT")
	}
];

const reportTypeSelection = [
	{ id: 1, name: i18n.t("COMMON.TITLE_DETAILS") },
	{ id: 2, name: i18n.t("COMMON.TITLE_SUMMARY") }
];

const reportOptionSelection = [
	{ id: "m3", name: i18n.t("COMMON.LBL_M3") },
	{ id: "kg", name: i18n.t("COMMON.LBL_KG") },
	{ id: "amount", name: i18n.t("COMMON.LBL_AMOUNT") },
	{ id: "stk_desc_1", name: i18n.t("COMMON.LBL_STOCK_DESC1") },
	{ id: "stk_desc_2", name: i18n.t("COMMON.LBL_STOCK_DESC2") },
	{ id: "supplier", name: i18n.t("COMMON.LBL_SUPPLIER") }
];

const loadingStatusSelection = [
	{
		id: 0,
		name: i18n.t("COMMON.STATUS.OPEN")
	},
	{
		id: 1,
		name: i18n.t("COMMON.STATUS.CLOSED")
	}
];

const categoryTypeSelection = async function (data = {}) {
	let response = await ApiService.post(`category-type/selection`, data);
	return response.data.code == "200" ? response.data.result : [];
};

const paymentTypeSelection = function () {
	return [
		{ id: 1, name: i18n.t("COMMON.PAYMENT.OUTSTANDING") },
		{ id: 2, name: i18n.t("COMMON.PAYMENT.FULLY_PAID") },
		{ id: 3, name: i18n.t("COMMON.PAYMENT.CLOSED_ORDER") },
		{ id: 4, name: i18n.t("COMMON.PAYMENT.FULLY_CANCELLED") }
	];
};

export default {
	warehouseSelection,
	warehouseCountrySelection,
	warehouseSettingsSelection,
	customerSelection,
	mainSalesmanSelection,
	salesmanSelection,
	deliveryZoneSelection,
	deliveryAddressSelection,
	companyGroupSelection,
	categoryLvl2Selection,
	taxSelection,
	supplierSelection,
	uploadFile,
	statusSelection,
	getCourierCompanySelection,
	getMaintainAgentSelection,
	getAgentCourierSelection,
	shipmentTypeSelection,
	countrySelection,
	markingSelection,
	refIdSelection,
	yesNoSelection,
	noticeTypeSelection,
	currencySelection,
	packingTypeSelection,
	userTypeSelection,
	userSelection,
	shipmentModeSelection,
	agentSelection,
	markingStatusSelection,
	callingCodeSelection,
	deliveryAgentSelection,
	epoStatusSelection,
	portSelection,
	refTypeSelection,
	numResetSelection,
	responseValidation,
	docTypeSelection,
	postingSideSelection,
	reportTypeSelection,
	reportOptionSelection,
	uomSelection,
	warehouseLocationSelection,
	loadingStatusSelection,
	categoryTypeSelection,
	paymentTypeSelection
};
